import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Sparkles } from "lucide-react";
import PhotoDrop from "@/components/PhotoDrop";

export default function PostCreate() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [image, setImage] = useState("");
  const [caption, setCaption] = useState("");
  const [title, setTitle] = useState("");
  const [aiLoad, setAiLoad] = useState(false);
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);

  const aiCap = async () => {
    setAiLoad(true);
    try {
      const { data } = await api.post("/ai/caption", { title, category: user?.category||"", description: caption });
      setCaption(data.caption);
    } catch (e) { setErr(formatErr(e)); }
    finally { setAiLoad(false); }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!image) { setErr("Please add a photo."); return; }
    setSaving(true); setErr("");
    try { await api.post("/posts", { image, caption }); nav("/feed"); }
    catch (e) { setErr(formatErr(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-8 py-10">
      <p className="overline mb-3">Share your work</p>
      <h1 className="h-display text-4xl mb-8">What did you make today?</h1>

      <form onSubmit={submit} className="card p-7 space-y-5" data-testid="post-form">
        <div>
          <span className="text-sm text-[#4A4A4A] mb-2 block">Photo</span>
          <PhotoDrop value={image} onChange={setImage} aspect="wide" label="Drop your photo here" testid="post-image-drop" maxSize={1600} />
        </div>
        <label className="block">
          <span className="text-sm text-[#4A4A4A]">Title or short description (for AI)</span>
          <input className="input mt-1.5" value={title} onChange={(e)=>setTitle(e.target.value)} placeholder="Tonight's tagliatelle" data-testid="post-title"/>
        </label>
        <label className="block">
          <span className="text-sm text-[#4A4A4A] flex items-center justify-between">
            Caption
            <button type="button" onClick={aiCap} disabled={aiLoad || !title} className="btn-ghost text-[#0057FF]" data-testid="ai-caption-btn">
              <Sparkles size={14}/> {aiLoad?"…":"Write with AI"}
            </button>
          </span>
          <textarea required rows={3} className="input mt-1.5" value={caption} onChange={(e)=>setCaption(e.target.value)} data-testid="post-caption"/>
        </label>
        {err && <p className="text-sm text-[#B84B4B]" data-testid="post-error">{err}</p>}
        <button className="btn-primary" disabled={saving} data-testid="post-submit">{saving?"Publishing…":"Publish to feed"}</button>
      </form>
    </div>
  );
}
